<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb :crumbs="[$t('menu.settings'), $t('text.list')]">
      </breadcrumb>
      <div class="container">
        <el-form
          ref="configForm"
          :model="config"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item :prop="'createOrderFixShop'">
                  <el-checkbox size="small" v-model="config.createOrderFixShop">
                    {{ $t("config.createOrderFixShop") }}
                  </el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              v-if="
                Permit.currentTenant() &&
                Permit.currentTenant().chargeW &&
                !Permit.isFreeEdition()
              "
              :gutter="10"
            >
              <el-col :span="6">
                <el-form-item :prop="'loginNotify'">
                  <el-checkbox size="small" v-model="config.loginNotify">{{
                    $t("config.loginNotify")
                  }}</el-checkbox>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit"
              >{{ $t("text.submit") }}</el-button
            >
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Config from "@/api/config.js";
import Tenant from "@/api/tenant.js";
import User from "@/api/user.js";
import ls from "store2";

export default {
  mixins: [page],
  components: {},
  data() {
    return {
      tenant: null,
      saveDoing: false,
      config: {
        nearDays: null,
        dealType: null,
        publishMessage: false,
        loginNotify: false,
        financeVerifyStrict: false,
        deliveryStrict: false,
        autoAsyncPurchase: false,
        createOrderFixShop: false,
        invNeedPickPush: false,
        mmsInvUseCash: false,
        mesSchedule: false,
      },
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadData();
  },
  methods: {
    //
    saveSubmit() {
      const self = this;
      self.saveDoing = true;
      Config.update(this.config.id, self.config).then(function (res) {
        self.saveDoing = false;
        self.$message({
          message: self.$t("prompt.saveSuccess"),
          type: "success",
        });
        self.loadData();
        self.getUser();
      });
    },

    loadData() {
      const self = this;
      self.loadingStart();
      Config.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.config = res.data;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },

    getUser() {
      const self = this;
      User.findById(self.Permit.currentUser().id).then(function (res) {
        if (res.data.code === 200) {
          ls.session("TENANT", res.data.entity.tenant);
          ls.session("USER", res.data.entity);
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.clear-data-prompt {
  color: #ff9b6a;
}
.clear-data-prompt li {
  line-height: 30px;
}
</style>